/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface ICategory {
        name: string;
    }

    export class Category implements ICategory {
        public name: string;

        public static Empty(): Category {
            return new Category('');
        }

        constructor(name: string) {
            this.name = name;
        }
    }
}